import React from 'react'
import { INFTCard } from './INFTCard'
import NFTCardFormater from '../../nftComponents/Cards';
import { NFTURLItems } from '../../data/NFTURLItems'

export function NFTCard(props: INFTCard) {
  const detailUrl = NFTURLItems.NFT_DETAIL

  return <React.Fragment>{NFTCardFormater({ ...props, detailUrl })}</React.Fragment>
}
